import React, { useRef, useState } from 'react';
import Icon from '../../../core/Icon';
import { Pencil, Trash } from '../../../../../assets/images/index';
import {
  StyledLabel,
  StyledWrapperGroupInput,
  StyledFileInput,
  StyledButtonPencil
} from './style';

const FileDropInput = ({ title, document, onFileChange, onTitleChange }) => {
  const [isDragging, setIsDragging] = useState(false);
  const inputFileRef = useRef();

  const handleDrop = e => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      onFileChange(file);
    }
  };
  const onDeleteFileClick = () => {
    onFileChange(null);
    onTitleChange('');
    inputFileRef.current.value = '';
  };
  return (
    <>
      <StyledLabel>Archivo *</StyledLabel>

      <StyledWrapperGroupInput
        isDragging={isDragging}
        onDragOver={e => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={handleDrop}
        aria-readonly="true"
      >
        <StyledFileInput
          id="fileName"
          name="fileName"
          type="text"
          value={title}
          placeholder="Pulse el lapicero o arrastre un archivo"
          onChange={e => onTitleChange(e.target.value)}
        />

        {!document.id && (
          <>
            <StyledButtonPencil>
              <Icon
                hover
                size="m"
                color="main"
                svg={Pencil}
                onClick={() => inputFileRef.current.click()}
              />
            </StyledButtonPencil>
            {title && (
              <StyledButtonPencil>
                <Icon
                  hover
                  size="m"
                  color="main"
                  svg={Trash}
                  onClick={() => onDeleteFileClick()}
                />
              </StyledButtonPencil>
            )}
            <input
              id="fileUpload"
              name="fileUpload"
              type="file"
              ref={inputFileRef}
              onChange={e => onFileChange(e.target.files?.[0])}
              hidden
            />
          </>
        )}
      </StyledWrapperGroupInput>
    </>
  );
};

export default FileDropInput;
